/** Every `P.*` parameter of spec §16 with its default. Override by spreading. */
export const DEFAULT_PARAMS = {
  // the run
  leadInBars: 2,
  rewindBars: 1,
  tailBars: 2,
  fadeIn: 1.5,
  fadeOut: 1.5,
  failFade: 0.15,
  lookahead: 0.2,
  skipContextChords: 4,
  // progression
  neededDefault: 1,
  minQuiz: 4,
  maxSpanChords: 8,
  minQuizStart: 20,
  // the wheel (units of R): the minor and the diminished ring inside the major; the wheel's
  // radius as a fraction of the viewport's smaller side; the hit radius of a star
  minorR: 0.74,
  dimR: 0.5,
  wheelR: 0.4,
  hitRadius: 0.12,
  // calibration (ms)
  calClicks: 16,
  calIOI: 500,
  tapBias: 30,
  calMax: 500,
  calIQR: 80,
  // synthesis (s / ms)
  thudMs: 320,
  // the night ambience: a factor on the encoded loop (−23 LUFS), spec §11
  ambienceGain: 0.1,
  // fellow observers in the atlas (visual §8): the fewest others to compare against, and the
  // share of all observers the player must be among for the line to be said
  observersMin: 10,
  observersShare: 0.2,
  // constellation (the pen: tangent swing as a factor of the neighbouring distances, spec §12)
  swingSlow: 0.7,
  swingFast: 0.45,
  widthSlow: 0.022,
  widthFast: 0.014,
  swingRepeat: 0.25,
  swingBias: 12,
  dwellMin: 0.06,
  dwellGain: 0.04,
  faintAlpha: 0.3,
  samplesPerSegment: 32,
  strokeSeconds: 5,
  revealStep: 0.6,
  ink: '#1B2237',
  // ingest
  bitrate: 160,
  analyseJobs: 4,
} as const

type Widen<T> = T extends number ? number : T extends string ? string : T
export type Params = {
  -readonly [K in keyof typeof DEFAULT_PARAMS]: Widen<(typeof DEFAULT_PARAMS)[K]>
}
